var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-12 h-6 rounded-full shadow inline-block focus-within:shadow-outline focus-within:outline-none",class:[
    _vm.value ? 'bg-green-500' : 'bg-gray-500',
    _vm.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
  ],attrs:{"title":_vm.title},on:{"click":function($event){!_vm.disabled && _vm.$emit('change', !_vm.value)}}},[_c('div',{staticClass:"w-1/2 h-full bg-white rounded-full shadow",style:({
      transform: ("translateX(" + (_vm.value ? 100 : 0) + "%)"),
      'transition-duration': ".25s"
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }